export default [
  // 在班人数统计
  {
    name: 'fullClassRate-detail',
    component: () => import(/* webpackChunkName: "fullClassRateDetailPopup" */ './popup/fullClassRate-detail.vue'),
  },
  // 在班学员明细
  {
    name: 'inClassNum-detail',
    component: () => import(/* webpackChunkName: "inClassNumDetailPopup" */ './popup/inClassNum-detail.vue'),
  },
];
